import { render, staticRenderFns } from "./UnsoldBills.vue?vue&type=template&id=33ad73b9&scoped=true&"
import script from "./UnsoldBills.vue?vue&type=script&lang=ts&"
export * from "./UnsoldBills.vue?vue&type=script&lang=ts&"
import style0 from "./UnsoldBills.vue?vue&type=style&index=0&id=33ad73b9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33ad73b9",
  null
  
)

export default component.exports